module.exports = window.T['views/lineplot.html'] || "<svg class=\"bblineplot\"></svg>";